import React, { useCallback, useRef, useState } from 'react';
import { Config } from '@leverege/plugin';
import { MultiSelector } from '@leverege/ui-elements';
import EditorUtil from "./EditorUtil.js";
import PopupEditorWrapper from "./PopupEditorWrapper.js";
import { jsx as _jsx } from "react/jsx-runtime";
const opts = {
  table: {
    embed: true,
    isRenderer: true,
    blockChildren: false
  },
  detail: {
    embed: true,
    isRenderer: true,
    blockChildren: false
  }
};
export default {
  valueType: 'string*',
  getOptions: usage => {
    return Config.get('AttributeStringArrayEditor', usage, opts[usage]);
  },
  create: opts => {
    const {
      usage,
      style,
      context,
      attribute,
      editable,
      canSet,
      variant,
      children,
      ...options
    } = opts;
    return /*#__PURE__*/_jsx(PopupEditorWrapper, {
      ...options,
      style: style // This makes it follow colorizers
      ,
      variant: EditorUtil.getVariant(usage, 'stringArray', 'editor'),
      autoFocus: usage !== 'form',
      usage: usage,
      editable: editable,
      Editor: Editor,
      allowCreate: true,
      children: children
    });
  }
};
function Editor(props) {
  const {
    value,
    variant,
    onChange: pOnChange,
    eventData,
    ...options
  } = props;
  const [val, setValue] = useState(value);
  const valueRef = useRef(value);
  const domRef = useRef();
  const onChange = useCallback(evt => {
    setValue(evt.value);
    valueRef.current = evt.value;
  }, []);
  const onRealChange = useCallback(() => {
    pOnChange({
      data: eventData,
      value: valueRef.current
    });
  }, [eventData, pOnChange]);
  const onBlur = useCallback(evt => {
    evt.stopPropagation();
    if (!evt.currentTarget.contains(evt.relatedTarget)) {
      setTimeout(onRealChange, 10);
    }
  }, [onRealChange]);
  return /*#__PURE__*/_jsx("div", {
    onBlur: onBlur,
    ref: domRef
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    ,
    tabIndex: 0,
    children: /*#__PURE__*/_jsx(MultiSelector, {
      ...options,
      variant: variant,
      value: val,
      onChange: onChange,
      eventData: eventData
    })
  });
}